import React from 'react';
import { Point } from '../__generated__/types';

export interface DriverLocation {
    latitude: number
    longitude: number
}

interface MapContextValue {
    points: Point[]
    route: GeoJSON.FeatureCollection | null
    setRoute: (route: GeoJSON.FeatureCollection | null) => void
    distance: number
    setDistance: (distance: number) => void
    driverLocation: DriverLocation | null
    setDriverLocation: (driverLocation: DriverLocation | null) => void
    addPointByCoords: (coords: [number, number]) => void
    addPointByAddress: (point: Point) => void
    removePoint: (point: Point) => void
    updateOrderPoints: (points: Point[]) => void
}

export const MapContext = React.createContext<MapContextValue>(null!);
